<template>

  <LayoutPane
    name      = "File Toolbar"
  >

    <div class="actions">

      <FileToolbarButton
        label     = "Watchers"
        :visible  = "layout.fileToolbar.actions.watchers"
        @toggle   = "layout.fileToolbar.actions.watchers = !layout.fileToolbar.actions.watchers"
      >
      </FileToolbarButton>

      <FileToolbarButton
        label     = "Clip Link"
        :visible  = "layout.fileToolbar.actions.cliplink"
        @toggle   = "layout.fileToolbar.actions.cliplink = !layout.fileToolbar.actions.cliplink"
      >
      </FileToolbarButton>

      <FileToolbarButton
        label     = "Close"
        :visible  = "layout.fileToolbar.actions.close"
        @toggle   = "layout.fileToolbar.actions.close = !layout.fileToolbar.actions.close"
      >
      </FileToolbarButton>

      <FileToolbarButton
        label     = "Browse"
        :visible  = "layout.fileToolbar.actions.browse"
        @toggle   = "layout.fileToolbar.actions.browse = !layout.fileToolbar.actions.browse"
      >
      </FileToolbarButton>

      <FileToolbarButton
        label     = "History"
        :visible  = "layout.fileToolbar.actions.history"
        @toggle   = "layout.fileToolbar.actions.history = !layout.fileToolbar.actions.history"
      >
      </FileToolbarButton>

    </div>

  </LayoutPane>

</template>

<script>

// #region Imports

/* Telestream */
import FileToolbarButton from './FileToolbarButton.vue';
import LayoutPane from './LayoutPane.vue';

// #endregion Imports

export default {

  // #region Properties

  props: {
    layout: Object
  },
  components: {
    LayoutPane,
    FileToolbarButton
  }

  // #endregion Properties

}

</script>

<style scoped lang="scss">

.actions {
  display:          flex;
  flex-direction:   row;
  gap:              8px;
  justify-content:  flex-end;
}

</style>